import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import "./LecteurFilm.css";

export default function LecteurFilm() {
  const { idFilm } = useParams();
  const navigate = useNavigate();
  const apiKey = "9b2511a35c2a1b656502230e8819a81c";
  const [trailer, setTrailer] = useState(null);
  const [filmTitle, setFilmTitle] = useState("");

  useEffect(() => {
    fetch(`https://api.themoviedb.org/3/movie/${idFilm}?api_key=${apiKey}&append_to_response=videos&language=fr-FR`)
      .then(res => res.json())
      .then(data => {
        const video = data.videos.results.find(v => v.type === "Trailer" && v.site === "YouTube");
        setTrailer(video?.key);
        setFilmTitle(data.title);
      });
  }, [idFilm]);

  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  if (!trailer) return <div className="player-loading">Chargement du lecteur...</div>;

  return (
    <div className="player-overlay" onClick={() => navigate(-1)}>
      <div className="player-modal" onClick={(event) => event.stopPropagation()}>
        <button className="player-close" type="button" onClick={() => navigate(-1)}>
          Fermer
        </button>
        <div className="player-header">
          <h2>{filmTitle}</h2>
          <span>Lecture du trailer</span>
        </div>
        <div className="player-iframe-wrapper">
          <iframe
            className="player-iframe"
            src={`https://www.youtube.com/embed/${trailer}?autoplay=1`}
            allow="autoplay; encrypted-media"
            allowFullScreen
            title="Lecteur de film"
          />
        </div>
      </div>
    </div>
  );
}
